import styled, { css } from 'styled-components';

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid black;
  border-radius: ${props => props.theme.borderRadius || 0};

  ${({
    error, theme, border, rightSideInInput, disabled,
  }) => {
    if (!rightSideInInput) {
      return css`
        border: 0;
      `;
    }
    if (border) {
      return css`
        border: ${border};
      `;
    } else if (error) {
      return css`
        border: 3px solid ${theme.danger};
      `;
    }

    return css`
      border: thin solid ${theme.borderColor};
    `;
  }}

  ${({ disabled, rightSideInInput, theme }) => {
    if (disabled && rightSideInInput) {
      return css`
        background: ${theme.disabledInputBackground || '#eee'};
      `;
    }
  }}
`;

export default InputContainer;
